
                import "css-modules://src_components_info"
                export default {"Main":"_06ff1d","Eyebrow":"_0d4d9a","Title":"_2db789","Text":"_302284","Navigation":"_8d4459"}
            